import { useMemo } from 'react';
import type { V2Agreement } from '../../domain/agreement';
import { useT } from '../../i18n/i18n';
import { AGREEMENT_CSS, renderAgreementDocumentBody } from '../../report/agreementHtml';
import { Button, SheetShell } from '../../ui/components';
import type { AgreementSubject } from './AgreementCard';

// 查看协议 (Round 2 §C): the full fixed document as the client signs it — in the language chosen for the
// client, whatever the App Language (Owner 2026-10-28; bilingual for one signed under an older copy) —
// with the approved scope text, the New York clauses in their English legal text, the variable fields
// of THIS inspection and the signature state, rendered by the same code that produces the agreement PDF.
export function AgreementViewSheet(props: { agreement: V2Agreement; subject: AgreementSubject; onClose: () => void; layer?: 'base' | 'over' }) {
  const { t } = useT();
  const html = useMemo(() => renderAgreementDocumentBody({ ...props.subject, agreement: props.agreement }, Date.now()), [props.agreement, props.subject]);
  return (
    <SheetShell
      full
      title={t('agreement.documentTitle')}
      subtitle={t('agreement.viewSubtitle')}
      onClose={props.onClose}
      layer={props.layer}
      testId="agreement-view-sheet"
      footer={
        <Button variant="secondary" onClick={props.onClose} testId="agreement-view-close">
          {t('shell.close')}
        </Button>
      }
    >
      <style>{AGREEMENT_CSS}</style>
      <div className="agreement-doc" data-testid="agreement-document" dangerouslySetInnerHTML={{ __html: html }} />
      {/* Owner-frozen AI notice (2026-09-13 §29 / §30 A): under the whole document, short, red. The
          legal text itself is untouched (§39). */}
      <p className="ai-disclaimer agreement-ai-disclaimer" data-testid="agreement-ai-disclaimer">
        {t('ai.disclaimer')}
      </p>
    </SheetShell>
  );
}
